// Plain document.cookie, not localStorage - the user specifically wants
// this to expire on its own eventually (a "long-lived" dismissal, not a
// truly permanent one), which a cookie's own `expires` gives for free
// with no extra bookkeeping. No backend involved - purely client-side.
const DISMISS_COOKIE = "installBannerDismissed";
const DISMISS_DAYS = 180;

export const isInstallBannerDismissed = () =>
  document.cookie.split("; ").some((entry) => entry.startsWith(`${DISMISS_COOKIE}=`));

export const dismissInstallBanner = () => {
  const expires = new Date(Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${DISMISS_COOKIE}=1; expires=${expires}; path=/; SameSite=Lax`;
};

export const isIos = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

// Already running as the installed app, not a browser tab - iOS exposes
// this as navigator.standalone (Safari-only, non-standard); everywhere
// else it's the standard display-mode media query.
export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
